import { investigationTypes, links, placeholders, territorialEntity, values } from './case-data';
import { searchQuery } from './../../actions/global-actions';
import Swal from 'sweetalert2';
import { provinces } from './../../actions/global-actions-data';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../styles/cases.css';
import { getCase, updateCase } from './../../actions/case-actions';
import { Link, useParams } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import { getDocumentData } from '../../actions/documents-actions';
import logoVAF from '../../assets/logo-abogados-vaf.jpeg';
import logoAH from '../../assets/logo-abogados-ah.png';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { templateData } from './case-data';
import { renderToString } from 'react-dom/server';

function EditCase(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [loadData, setLoadData] = useState(true);
    const [needUpdate, setNeedUpdate] = useState(false);
    const [needSave, setNeedSave] = useState(false);
    const [showCommentDiv, setShowCommentDiv] = useState(false);
    const [closeComment, setCloseComment] = useState("");

    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [dropdown, setDropdown] = useState({
        show: false,
        value: '',
        data: []
    })

    const [form, setForm] = useState({
        date: new Date(),
        client: {
            clientId: ''
        },
        clientText: '',
        attorneyInCharge: {
            userId: ''
        },
        attorneyText: '',
        representative: '',
        caseType: '',
        case: {
            position: '',
            statePosition: '',
            territorialEntity: '',
            executionProvince: '',
            executionCity: '',
        },
        researchOrgan: {
            organId: ''
        },
        researchOrganText: '',
        filingNumber: '',
        city: '',
        province: '',
        summary: '',
        observation: '',
        events: '',
        instance: '',
        autoOpening: '',
        autoOpeningDate: '',
        notificationDate: '',
        companyText: '',
        status: '',
        authority: {
            generated: false,
            generationDate: new Date()
        },
        policy: {
            generated: false,
            generationDate: new Date()
        },
        defenseStrategy: {
            generated: false,
            generationDate: new Date()
        },
        fee: {
            generated: false,
            generationDate: new Date()
        },
        legalityControl: {},
        legalCompany: 'AYH',
        caseStatus: 'Abierto'
    })

    const [currentData, setCurrentData] = useState({})

    const [currentLinks, setCurrentLinks] = useState([]);

    useEffect(() => {
        const setCaseCities = ( caseProvince, clientProvince ) => {
            const caseCities = provinces.find( x => x.name === caseProvince).cities;
            const clientCities = provinces.find( x => x.name === clientProvince).cities;
            setCitiesData({
                caseCities,
                clientCities
            })
        }

        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log('datos', data.data);

                    let newLinks = JSON.parse(JSON.stringify(links));

                    if ( data.data.valueLetters === 'SIN HONORARIOS' || ('company' in data.data && data.data.company.companyId.description === 'SIN ASEGURADORA') ) {
                        newLinks.splice(1, 3);
                    }
                    
                    //console.log('newLinks', newLinks);

                    if (data.data.legalityControl.pass && 'proof' in data.data.legalityControl) {
                        newLinks.push({ name: 'Control de legalidad', value: 'control'});
                    }

                    setCurrentLinks(newLinks);

                    let clientText = data.data.client.clientId.firstName + ' ' + data.data.client.clientId.lastName + ' ' + data.data.client.clientId.documentType + ': ' + data.data.client.clientId.document;
                    let attorneyText =  data.data.attorneyInCharge.userId.firstName + ' ' + data.data.attorneyInCharge.userId.lastName + ' ' + data.data.attorneyInCharge.userId.documentType + ': ' + data.data.attorneyInCharge.userId.document + ' TP:' + data.data.attorneyInCharge.userId.professionalCard;
                    let researchOrganText =  data.data.researchOrgan.organId.description;

                    let newDate = new Date(data.data.date);
                    let newAutoOpeningDate = new Date(data.data.autoOpeningDate);
                    let newNotificationDate = new Date(data.data.notificationDate);

                    data.data.caseStatus = data.data.caseStatus? data.data.caseStatus: 'Abierto';
                    data.data.legalCompany = data.data.legalCompany? data.data.legalCompany: 'AYH';
                    data.data.legalCompanyText = data.data.legalCompany==='VAF'?'VAF LEGAL S.A.S.':'A&H Abogados - Grupo Jurídico Especializado';
                    data.data.positionText = data.data.legalCompany==='VAF'?'Representante Legal VAF LEGAL S.A.S. NIT. 901638132-1':'Abogado';
                    data.data.bankAccountNumberText = data.data.legalCompany==='VAF'?'108900227555':'010470013169';

                    if (data.data.status === "not checked") {
                        data.data.statusText = "Sin revisar"
                    }
                    if (data.data.status === "checked") {
                        data.data.statusText = "Revisado"
                    }
                    if (data.data.status === "finished") {
                        data.data.statusText = "Terminado"
                    }

                    setCaseCities( data.data.province, data.data.case.executionProvince );
                    setCurrentData(data.data);
                    
                    if (data.data.company) {
                        let companyText =  data.data.company.companyId.description;
                        setForm({
                            ...form,
                            ...data.data,
                            date: newDate,
                            clientText,
                            attorneyText,
                            researchOrganText,
                            companyText,
                            autoOpeningDate: newAutoOpeningDate,
                            notificationDate: newNotificationDate
                        })
                    } else {
                        if (user.userType === "Abogado") {
                            setForm({
                                ...form,
                                ...data.data,
                                date: newDate,
                                clientText,
                                attorneyText,
                                researchOrganText,
                                companyText: 'co',
                                autoOpeningDate: newAutoOpeningDate,
                                notificationDate: newNotificationDate
                            })
                        } else {
                            setForm({
                                ...form,
                                ...data.data,
                                date: newDate,
                                clientText,
                                attorneyText,
                                researchOrganText,
                                autoOpeningDate: newAutoOpeningDate,
                                notificationDate: newNotificationDate
                            })
                        }
                    }
                }
            }

            setLoadData(false);
            setNeedSave(false);
            setForm({
                date: new Date(),
                client: {
                    clientId: ''
                },
                clientText: '',
                attorneyInCharge: {
                    userId: ''
                },
                attorneyText: '',
                representative: '',
                caseType: '',
                case: {
                    position: '',
                    statePosition: '',
                    territorialEntity: '',
                    executionProvince: '',
                    executionCity: '',
                },
                researchOrgan: {
                    organId: ''
                },
                researchOrganText: '',
                filingNumber: '',
                city: '',
                province: '',
                summary: '',
                observation: '',
                events: '',
                instance: '',
                autoOpening: '',
                autoOpeningDate: '',
                notificationDate: '',
                companyText: '',
                status: '',
                authority: {
                    generated: false,
                    generationDate: new Date()
                },
                policy: {
                    generated: false,
                    generationDate: new Date()
                },
                defenseStrategy: {
                    generated: false,
                    generationDate: new Date()
                },
                fee: {
                    generated: false,
                    generationDate: new Date()
                },
                legalityControl: {},
                legalCompany: 'AYH',
                caseStatus: 'Abierto'
            });
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.userType, user.token ]);

    const [citiesData, setCitiesData] = useState({
        caseCities: [],
        clientCities: []
    });

    const handleInputChange = (event) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            })
        }
    }

    const handleCaseInputChange = (event) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                case: {
                    ...form.case,
                    [event.target.name] :  event.target.value
                }
            })
        }
    }

    const handleDateChange = ( name, date ) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                [name] :  date
            })
        }
    }

    const handleSearchChange = (event) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            })
            if (event.target.value.length > 2) {
                dispatch( searchQuery( event.target.id, event.target.value, searchFunction, user.token ) );
            } else {
                setDropdown({ show: false, value: '', data: [] });
            }
        }
    }

    const searchFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setDropdown({ show: true, value: link, data: data.data });
        }
    }

    const setOrganData = ( data ) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                researchOrgan: {
                    organId: data._id
                },
                researchOrganText: data.description
            })
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const setClientData = ( data ) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                client: {
                    clientId: data._id
                },
                clientText: data.firstName + ' ' + data.lastName + ' ' + data.documentType + ': ' + data.document,
            })
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const setAttorneyData = ( data ) => {
        if (currentData.caseStatus === 'Abierto') {
            setForm({
                ...form,
                attorneyInCharge: {
                    userId: data._id
                },
                attorneyText: data.firstName + ' ' + data.lastName + ' ' + data.documentType + ': ' + data.document + ' TP:' + data.professionalCard,
            })
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const setCompanyData = ( data ) => {
        if (currentData.caseStatus === 'Abierto') {
            if (form.status === "not checked") {
                setForm({
                    ...form,
                    company: {
                        companyId: data._id
                    },
                    companyText: data.description,
                    status: 'checked'
                })
                setNeedSave(true);
            } else {
                setForm({
                    ...form,
                    company: {
                        companyId: data._id
                    },
                    companyText: data.description
                })
            }
            setDropdown({ show: false, value: '', data: [] });
        }
    }

    const handleValueChange = (event) => {
        if (currentData.caseStatus === 'Abierto') {
            if (event.target.value) {
                let value = values.find( obj => obj.valueNumber ===  event.target.value);
                return setForm({
                    ...form,
                    valueLetters: value.valueLetters,
                    valueNumber: value.valueNumber,
                })
            }
            return setForm({
                ...form,
                valueLetters: '',
                valueNumber: '',
            })
        }
    }

    const handleOnChange = (event, position) => {
        if (currentData.caseStatus === 'Abierto') {
            const value = event.target.value;
            if (value !== '' && value) {
                const cities = provinces.find( x => x.name === value).cities;
                if (position === 'case') {
                    setCitiesData({
                        ...citiesData,
                        showCities: true,
                        position,
                        caseCities: cities
                    })
                    setForm({
                        ...form,
                        [event.target.name]: event.target.value
                    })
                } else {
                    setCitiesData({
                        ...citiesData,
                        showCities: true,
                        position,
                        clientCities: cities
                    })
                    setForm({
                        ...form,
                        case: {
                            ...form.case,
                            [event.target.name]: event.target.value
                        }
                    })
                }      
            } else {
                if (position === 'case') {
                    setCitiesData({
                        ...citiesData,
                        showCities: false,
                        caseCities: []
                    })
                    setForm({
                        ...form,
                        city :  '',
                        province: ''
                    })
                } else {
                    setCitiesData({
                        ...citiesData,
                        showCities: false,
                        clientCities: []
                    })
                    setForm({
                        ...form,
                        case: {
                            ...form.case,
                            executionCity :  '',
                            executionProvince: ''
                        }
                    })
                }
            }
        }
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        if (currentData.caseStatus === 'Abierto') {
            const isEmpty = validateFields();
            if (isEmpty) {
                return Swal.fire({
                    title:"¡Atención!",
                    confirmButtonColor:"#76b4ff",
                    text:"Debe llenar todos los datos para continuar",
                });
            } else {
                return dispatch( updateCase(form,updateFunction, user.token) );
            }
        }
        return Swal.fire({
            title:"¡Atención!",
            confirmButtonColor:"#76b4ff",
            text:"No puede actualizar la información de un caso cerrado",
        });
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( field !== 'topics' && field !== 'representative' && (form[field] === '' || form[field] === null)) {
                    return true
                }
            }
        }
        return false
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //navigate(currentLink)
            //console.log(data);
            setNeedSave(false)
            setLoadData(true);

            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Caso actualizado con éxito"
            });
        }
    }

    /*
    const updateStatus = (event, status) => {
        event.preventDefault();
        const isEmpty = Object.values(form).some(x => x === null || x === '');
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
        } else {
            setForm({
                ...form,
                status
            })
            setNeedUpdate(true);
        }
        //console.log('enviando form...' + form.nombre + ' ' + form.apellido)
    }*/

    const downloadDocuments = () => {
        let date = new Date();
        let wasChanged = false;
        if ( !form.policy.generated ) {
            wasChanged = true;
            form.policy = {
                generated: true,
                generationDate: date
            }
        }
        if ( !form.defenseStrategy.generated ) {
            if (!wasChanged) {
                wasChanged = true;
            }
            form.defenseStrategy = {
                generated: true,
                generationDate: date
            }
        }
        if ( !form.fee.generated ) {
            if (!wasChanged) {
                wasChanged = true;
            }
            form.fee = {
                generated: true,
                generationDate: date
            }
        }

        if ( form.status !== "finished" ) {
            if (!wasChanged) {
                wasChanged = true;
            }
            form.status = 'finished'
        }

        if (wasChanged) {
            setForm({...form});
            setNeedUpdate(true);
        }

        const documents = [
            {
                name: 'policy',
                documentName: '5 POLIZA'
            },
            {
                name: 'defense',
                documentName: '6 DEFENSA'
            },
            {
                name: 'fee',
                documentName: '7 HONORARIOS'
            },
        ]

        for (let index = 0; index < documents.length; index++) {
            const Element = () => getDocumentData(documents[index].name, form);

            let wrapper= document.createElement('div');
            wrapper.innerHTML= (renderToString(<Element/>));

            let doc = new jsPDF('p', 'pt', 'a4');
            const element = wrapper.firstChild;
            const marginX = 20;    
            const opt = {
                margin: [38, marginX, 23, marginX],
                filename: `${documents[index].documentName} ${form.client.clientId.lastName.toUpperCase()} EXP ${form.filingNumber}.pdf`,
                enableLinks: false,
                pagebreak: {
                  avoid: ['br'],
                  mode: ['css', 'avoid-all'],
                },
                image: { type: 'jpeg', quality: 0.7 },
                html2canvas: {
                  allowTaint: true,
                  dpi: 300,
                  letterRendering: true,
                  logging: false,
                  scale: 2,
                  scrollX: 0,
                  scrollY: 0,
                },
                jsPDF: { doc },
              };
    
            html2pdf()
            .from(element)
            .set(opt)
            .toPdf()
            .get('pdf')
            .then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages();
                for (let i = 1; i < totalPages + 1; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(7);
    
                    let heightSpace = pdf.internal.pageSize.getHeight() - 12;
                    let logo = currentData.legalCompany === 'VAF'? logoVAF:logoAH;
                    const sizeX = currentData.legalCompany === 'VAF'? 38:33;
                    const sizeY = currentData.legalCompany === 'VAF'? 20:23;
                    let posX = pdf.internal.pageSize.getWidth()-(marginX+sizeX);
                    // Validación de espacio porque el logo tiene márgenes
                    posX = currentData.legalCompany === 'VAF'?(posX+4):posX;
                    const posY = 10;

                    // addImage(img, posX, posY, sizeX, sizeY) => posX = marginX+sizeX
                    pdf.addImage(logo, posX, posY, sizeX, sizeY);
    
                    Object.keys(templateData.company).map((keyName, i) => {
                        pdf.text(
                            `${templateData.company[keyName]}`,
                            (pdf.internal.pageSize.getWidth()/2)-(templateData.company[keyName].length/2),
                            heightSpace,
                        );
                        heightSpace += 3;
                        return i;
                    })
                    const pages = `${i}/${totalPages}`;
                    pdf.text(
                        pages,
                        (pdf.internal.pageSize.getWidth()/2)-(pages.length/2),
                        heightSpace,
                    );
                }
            })
            .save();
        }
    }

    const closeCase = (option) => {
        if(option === 1) {
            setShowCommentDiv(true);
            return;
        }
        if (window.confirm(`¿Realmente desea cerrar el caso: ${currentData.filingNumber}`)) {
            form.caseStatus = 'Cerrado';
            let comments = [...form.comments];
            let comment = {
                creationUser: user._id,
                comment: closeComment?closeComment:"El caso ha sido cerrado",
                type: "Estado del caso"
            }
            comments.push(comment);
            form.comments = comments;
            setForm({...form});
            setNeedUpdate(true);
            setShowCommentDiv(false);
        }
    }

    const openCase = () => {
        if (window.confirm(`¿Realmente desea abrir nuevamente el caso: ${currentData.filingNumber}`)) {
            form.caseStatus = 'Abierto';
            let comments = [...form.comments];
            let comment = {
                creationUser: user._id,
                comment: "El caso se ha vuelto a abrir",
                type: "Estado del caso"
            }
            comments.push(comment);
            form.comments = comments;
            setForm({...form});
            setNeedUpdate(true);
        }
    }

    useEffect(() => {
        if (needUpdate) {
            dispatch( updateCase( form, updateFunction, user.token) );
            setNeedUpdate(false);
            setLoadData(true);
        }
        //console.log(showCommentDiv);
    }, [needUpdate, dispatch, form, user.token ]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Editar caso</h1>
                {currentData && Object.keys(currentData).length > 0?
                    <form className="d-flex w-100 flex-wrap" onSubmit={handleOnSubmit}>
                        <h4 className="w-100 my-2">Datos Generales</h4>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">Fecha del documento</label>
                            <DatePicker
                                value={form.date}
                                dayAriaLabel={"Día"}
                                dayPlaceholder={"dd"}
                                monthAriaLabel={"Mes"}
                                monthPlaceholder={"mm"}
                                yearAriaLabel={"Año"}
                                yearPlaceholder={"yyyy"}
                                name={"date"}
                                onChange={ (date)=>handleDateChange( 'date', date ) }
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="caseType">Tipo de investigación</label>
                            <select className="input-field" id="caseType" name="caseType" onChange={handleInputChange} value={form.caseType}>
                                <option></option>
                                {investigationTypes.map((documentType, index) => (
                                    <option key={index} value={documentType.value}>{documentType.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="filingNumber">Radicado de la investigación</label>
                            <input type="text" className="input-field" id="filingNumber" placeholder="Número de radicado de investigación" onChange={handleInputChange} name="filingNumber" value={form.filingNumber}></input>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="province">Departamento</label>
                            <select className="input-field" id="province" name="province" onChange={(e) =>handleOnChange(e, 'case')} value={form.province}>
                                <option></option>
                                {provinces.map((province) => (
                                    <option key={province.name} value={province.name}>{province.name}</option>
                                ))}
                            </select>
                        </div>
                        {form.province !== '' && citiesData.caseCities && citiesData.caseCities !== [] ? 
                            <div className="d-flex flex-column w-3 field">
                                <label className="label-field" htmlFor="city">Ciudad del caso</label>
                                <select className="input-field" id="city" name="city" onChange={handleInputChange} value={form.city}>
                                    <option></option>
                                    {citiesData.caseCities.map((city) => (
                                        <option key={city.name} value={city.name}>{city.name}</option>
                                    ))}
                                </select>
                            </div>
                            :''}
                        <div className="d-flex flex-column w-3 field position-relative">
                            <label className="label-field" htmlFor="research-organ-or-control">Órgano de investigación</label>
                            <input type="text" autoComplete='off' className="input-field" id="research-organ-or-control" placeholder="Buscar órgano de investigación por su nombre" onChange={handleSearchChange} name="researchOrganText" value={form.researchOrganText}></input>
                            <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'research-organ-or-control') ? "active" : ""}`}>
                                { dropdown.data.length > 0 ?
                                    dropdown.data.map((option, index) => (
                                        <div key={index} className="dropdown-item-container" onClick={() => setOrganData(option)}>{option.description}</div>
                                    ))
                                :
                                    <span className="dropdown-message-item">Sin resultados, <a target="_blank" rel="noreferrer" href={"/organos-investigacion/nuevo"}>¿crear?</a></span>
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-column w-3 field position-relative">
                            <label className="label-field" htmlFor="attorney">Abogado a cargo</label>
                            <input type="text" autoComplete='off' className="input-field" id="user" placeholder="Buscar por nombres, apellidos o documento" onChange={handleSearchChange} name="attorneyText" value={form.attorneyText}></input>
                            <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'user') ? "active" : ""}`}>
                                { dropdown.data.length > 0 ?
                                    dropdown.data.map((option, index) => (
                                        <div key={index} className="dropdown-item-container" onClick={() => setAttorneyData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document} TP: {option.professionalCard}</div>
                                    ))
                                :
                                    <span className="dropdown-message-item">Sin resultados  
                                        { user.userType === 'Administrador' ? <a target="_blank" rel="noreferrer" href={"/usuarios/nuevo"}>, ¿crear?</a> : null}                        
                                    </span>
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field representative" htmlFor="representative">Personero delegado &#47; Funcionario sustenciador</label>
                            <input type="text" className="input-field" id="representative" name="representative" autoComplete="off" placeholder="" onChange={handleInputChange} value={form.representative}></input>
                        </div>
                        <h4 className="w-100 my-2">Datos del cliente</h4>
                        <div className="d-flex flex-column w-3 field position-relative">
                            <label className="label-field" htmlFor="client">Cliente</label>
                            <input type="text" autoComplete='off' className="input-field" id="client" placeholder="Buscar por nombres, apellidos o documento" onChange={handleSearchChange} name="clientText" value={form.clientText}></input>
                            <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'client') ? "active" : ""}`}>
                                { dropdown.data.length > 0 ?
                                    dropdown.data.map((option, index) => (
                                        <div key={index} className="dropdown-item-container" onClick={() => setClientData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document}</div>
                                    ))
                                :
                                    <span className="dropdown-message-item">Sin resultados, <a target="_blank" rel="noreferrer" href={"/clientes/nuevo"}>¿crear?</a></span>
                                }
                            </div>
                        </div>
                        <div  className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="position">Cargo</label>
                            <input name="position" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleCaseInputChange} value={form.case.position}></input>
                        </div>
                        <div  className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="statePosition">Estado del cargo</label>
                            <select className="input-field" id="statePosition" name="statePosition" onChange={handleCaseInputChange} value={form.case.statePosition}>
                                <option></option>
                                <option value="actual">Actualmente</option>
                                <option value="ex">Ex</option>

                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="territorialEntity">Entidad territorial</label>
                            <select className="input-field" id="territorialEntity" name="territorialEntity" onChange={handleCaseInputChange} value={form.case.territorialEntity}>
                                <option></option>
                                {territorialEntity.map((value) => (
                                    <option key={'territorialEntity' + value} value={value}>{value}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="executionProvince">Departamento de ejecución</label>
                            <select className="input-field" id="executionProvince" name="executionProvince" onChange={(e) =>handleOnChange(e, 'client')} value={form.case.executionProvince}>
                                <option></option>
                                {provinces.map((province) => (
                                    <option key={province.name} value={province.name}>{province.name}</option>
                                ))}
                            </select>
                        </div>
                        {form.case.executionProvince !== '' && citiesData.clientCities && citiesData.clientCities !== [] ? 
                            <div className="d-flex flex-column w-3 field">
                                <label className="label-field" htmlFor="executionCity">Ciudad de ejecución</label>
                                <select className="input-field" id="executionCity" name="executionCity" onChange={handleCaseInputChange} value={form.case.executionCity}>
                                    <option></option>
                                    {citiesData.clientCities.map((city) => (
                                        <option key={'executionCity' + city.name} value={city.name}>{city.name}</option>
                                    ))}
                                </select>
                            </div>
                            :''}
                        <h4 className="w-100 my-2">Datos particulares</h4>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'summary'}>Resumen</label>
                            <textarea id={'summary'} name={'summary'} placeholder={placeholders.summary} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.summary}></textarea>
                        </div>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'observation'}>Observaciones</label>
                            <textarea id={'observation'} name={'observation'} placeholder={placeholders.observation} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.observation}></textarea>
                        </div>
                        <div  className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'events'}>Acontecimientos</label>
                            <textarea id={'events'} name={'events'} placeholder={placeholders.events} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.events}></textarea>
                        </div>
                        <div  className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="instance">Instancia</label>
                            <select className="input-field" id="instance" name="instance" onChange={handleInputChange} value={form.instance}>
                                <option></option>
                                <option value="única">Única</option>
                                <option value="doble">Doble</option>
                            </select>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field" htmlFor="autoOpening">Auto de apertura</label>
                            <input type="text" className="input-field" id="autoOpening" placeholder="Ej: 1600.20.11.20.088" onChange={handleInputChange} name="autoOpening" value={form.autoOpening}></input>
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field">Fecha del auto de apertura</label>
                            <DatePicker
                                value={form.autoOpeningDate}
                                dayAriaLabel={"Día"}
                                dayPlaceholder={"dd"}
                                monthAriaLabel={"Mes"}
                                monthPlaceholder={"mm"}
                                yearAriaLabel={"Año"}
                                yearPlaceholder={"yyyy"}
                                name={"autoOpeningDate"}
                                onChange={ (date)=>handleDateChange( 'autoOpeningDate', date ) }
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>
                        <div className="d-flex flex-column w-50 field">
                            <label className="label-field">Fecha de notificación</label>
                            <DatePicker
                                value={form.notificationDate}
                                dayAriaLabel={"Día"}
                                dayPlaceholder={"dd"}
                                monthAriaLabel={"Mes"}
                                monthPlaceholder={"mm"}
                                yearAriaLabel={"Año"}
                                yearPlaceholder={"yyyy"}
                                name={"notificationDate"}
                                onChange={ (date)=>handleDateChange( 'notificationDate', date ) }
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>
                        {user.userType !== 'Abogado'?
                            <div  className="w-100 d-flex flex-wrap my-2">
                                <h4 className="w-100">{`Honorarios - ${currentData.statusText}`}</h4>
                                <div className="d-flex flex-column w-3 field position-relative">
                                    <label className="label-field" htmlFor="company-insurance">Aseguradora</label>
                                    <input type="text" autoComplete='off' className="input-field" id="company-insurance" placeholder="Buscar aseguradora por nombre" onChange={handleSearchChange} name="companyText" value={form.companyText}></input>
                                    <div className={`dropdown-container l ${(dropdown.show && dropdown.value === 'company-insurance') ? "active" : ""}`}>
                                        { dropdown.data.length > 0 ?
                                            dropdown.data.map((option, index) => (
                                                <div key={index} className="dropdown-item-container" onClick={() => setCompanyData(option)}>{option.description}</div>
                                            ))
                                        :
                                            <span className="dropdown-message-item">Sin resultados, <a target="_blank" rel="noreferrer" href={"/aseguradoras/nuevo"}>¿crear?</a></span>
                                        }
                                    </div>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="value">Valor a cobrar</label>
                                    <select className="input-field" id="value" name="value" 
                                        onChange={handleValueChange} 
                                        value={form.valueNumber}>
                                        <option></option>
                                        {values.map((value) => (
                                            <option key={value.valueNumber} value={value.valueNumber}>{value.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div  className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="legalCompany">Empresa</label>
                                    <select className="input-field" id="legalCompany" name="legalCompany" onChange={handleInputChange} value={form.legalCompany}>
                                        <option value="VAF">VAF LEGAL S.A.S.</option>
                                        <option value="AYH">A&#38;H Abogados</option>
                                    </select>
                                </div>
                            </div>
                        : ''}
                        {(user.userType !== 'Abogado' && currentData.caseStatus === 'Abierto') &&
                            <div className="d-flex justify-content-center w-100 my-2">
                                <button type="submit" className="primary-button save-button">Guardar</button>
                            </div>
                        }
                        {(currentData.status !== "not checked" && user.userType !== 'Abogado' && !needSave && currentData.caseStatus === 'Abierto') &&
                            <div  className="w-100 my-4">
                                <h4 className="w-100 mb-2">Documentos</h4>
                                <div className="d-flex justify-content-between w-100">
                                    {currentLinks.map( (link, index) => (
                                        <Link key={index} to={link.value} className="link-button">{link.name}</Link>
                                    ))}
                                </div>
                            </div>
                        }
                        {currentData.status !== "not checked" && user.userType !== 'Abogado' && !needSave 
                            && currentData.valueLetters !== 'SIN HONORARIOS' && ('company' in currentData && currentData.company.companyId.description !== 'SIN ASEGURADORA')
                            && currentData.caseStatus === 'Abierto' ?
                            <div className="d-flex justify-content-center w-100 my-2">
                                <button type="button" onClick={downloadDocuments} className="primary-button save-button">Descargar documentos</button>
                            </div>
                        : ''}
                        {currentData.status !== "not checked" ?
                            <div className="w-100 d-flex flex-wrap my-2">
                                <h4 className="w-100 mb-2">Control de legalidad</h4>
                                <div className="d-flex flex-column w-50 field">
                                    <label className="label-field">Estado</label>
                                    <span className='field'>
                                        {form.legalityControl.proof?(form.legalityControl.pass?'Aprobado':'Rechazado'):'No realizado'}
                                    </span>
                                </div>
                                {form.legalityControl.proof?
                                    <div className="d-flex flex-column w-50 field">
                                        <label className="label-field">Revisado por</label>
                                        <span className='field'>
                                            {`${form.legalityControl.reviewedUser.firstName} ${form.legalityControl.reviewedUser.lastName}`}
                                        </span>
                                    </div>
                                :null}
                                {!form.legalityControl.pass ?
                                    <div className="d-flex flex-column w-100 field">
                                        <label className="label-field">Razón</label>
                                        <span className='field'>{form.legalityControl.rejectionReason}</span>
                                    </div>
                                : null}
                                <div className="d-flex justify-content-center w-100 my-2">
                                    <Link to={`${currentLink}/control/${form._id}`} className="primary-button save-button">Ir al control</Link>
                                </div>
                            </div>
                        : null}
                        {currentData.status !== "not checked" && (Object.keys(currentData).length > 0) ?
                            <div className="w-100 d-flex flex-wrap my-2">
                                <h4 className="w-100 mb-2">Temas del caso</h4>
                                {currentData.topics?
                                    currentData.topics.topics.map( (topic, index)=>(
                                        <span key={index} className='m-2'>{topic.name}</span>
                                    ))
                                :
                                    null
                                }
                                <div className="d-flex justify-content-center w-100 my-2">
                                    {!currentData.topics?
                                        <Link to={`${currentLink}/temas/${form._id}/crear`} className="primary-button save-button">Crear temas</Link>
                                    :
                                        <Link to={`${currentLink}/temas/${form._id}/editar`} className="primary-button save-button">Ir al banco temático</Link>
                                    }
                                </div>
                            </div>
                        : null}
                        {currentData.status !== "not checked" && (Object.keys(currentData).length > 0) ?
                            <div className="w-100 d-flex flex-wrap my-2">
                                <h4 className="w-100 mb-2">Historial de seguimiento al caso</h4>
                                <div className="d-flex justify-content-center w-100 my-2">
                                    <Link to={`${currentLink}/historial/${params.id}`} className="primary-button save-button">Ir al historial</Link>
                                </div>
                            </div>
                        : null}
                        {currentData.caseStatus === "Abierto" && user.userType === 'Administrador' && !showCommentDiv ?
                            <div className="d-flex justify-content-center w-100 my-4">
                                <button type="button" onClick={()=>closeCase(1)} className="primary-button save-button">Cerrar caso</button>
                            </div>
                        : ''}
                        {showCommentDiv && 
                            <>
                                <div className="d-flex flex-column w-100 field">
                                    <label className="label-field" htmlFor="comment">Observación para el cierre del caso (opcional)</label>
                                    <textarea id={'comment'} name={'comment'} autoComplete="off" rows={5} cols={5} className="input-field" onChange={(e)=>setCloseComment(e.target.value)} value={closeComment}></textarea>
                                </div>
                                <div className="d-flex justify-content-center w-100 my-4">
                                    <button type="button" onClick={()=>closeCase(2)} className="primary-button save-button">Cerrar caso</button>
                                </div>
                            </>
                        }
                        {currentData.caseStatus === "Cerrado" && user.userType === 'Administrador' ?
                            <div className="d-flex justify-content-center w-100 my-4">
                                <button type="button" onClick={openCase} className="primary-button save-button">Reabrir caso</button>
                            </div>
                        : ''}
                    </form>
                :
                null}

            </div>
        </div>
    );
}

export default EditCase;